import React from "react";
import CardWrapper from "./CardWrapper";
import { Box } from "@mui/material";


/**
 * CardGridComponent
 * Renders a responsive grid layout of draggable and styled cards.
 *
 * @param {Array} cards - An array of card config objects:
 *  {
 *    id: string,
 *    title: string,
 *    content: ReactElement,
 *    size: "small" | "medium" | "large",
 *    shape: "rectangle" | "square",
 *    isDraggable?: boolean
 *  }
 */
 
 const CardGridComponent = ({ cards, isSidebarCollapsed }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: '24px', // Corresponds to Tailwind's gap-6
        // Define responsive columns directly. This will override any global CSS.
        gridTemplateColumns: {
          // Default: 1 column
          xs: 'repeat(1, 1fr)', 
          // Medium screens and up: 2 columns
          md: 'repeat(2, 1fr)', 
          // Large screens: Dynamically switch between 2 and 3 columns
          lg: isSidebarCollapsed ? 'repeat(3, 1fr)' : 'repeat(2, 1fr)',
        },
      }}
    >
      {cards.map((card) =>
        card?.content ? (
          <CardWrapper
            key={card.id}
            id={card.id}
            title={card.title}
            size={card.size}
            shape={card.shape}
            isDraggable={card.isDraggable}
          >
            {card.content}
          </CardWrapper>
        ) : null
      )}
    </Box>
  );
};

export default CardGridComponent;